import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import RoundedContainer from './roundedContainer';
import CTAButton from './ctaButton';
import DividerLine from './dividerLine';

const Countdown = ({ ...props }) => {

    const [duration, setDuration] = useState(null);
    const [seconds, setSeconds] = useState("");
    const [minutes, setMinutes] = useState("");
    const [hours, setHours] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [title, setTitle] = useState(props.title || "Countdown:")

    //Update Clock
    useEffect(() => {
        let interval = null;
        if (isActive) {
            interval = setInterval(() => {
                const tzNow = moment.tz('America/New_York').utcOffset();
                const tzTarget = moment(props.targetTime).utcOffset();
                const tzOffset = (tzNow - tzTarget)/60;
                const target = moment(props.targetTime).add(1,'seconds');
                const now = moment.tz('America/New_York');
                const newDuration = moment.duration(target - now);
                setHours(String(newDuration.hours() - tzOffset));
                setMinutes(String(newDuration.minutes()));
                setSeconds(String(newDuration.seconds()));
                setDuration(newDuration);        
                console.log("ND", newDuration);        
            }, 1000);
        } else if (!isActive && duration !== null) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [props.targetTime, duration, hours, minutes, seconds, isActive]);

    return (
        <div>
            <h2 className="text-center text-xl lg:text-4xl font-bold text-gray-700 py-2 w-full">{title}</h2>
            <p className="text-center text-lg sm:text-2xl text-red-500 font-bold px-4 pt-4 pb-6 lg:pb-20">
                {duration &&
                    (
                        
                        (hours.length == 1 ? '0' + hours : hours) + ':'
                        + (minutes.length == 1 ? '0' + minutes : minutes) + ':'
                        + (seconds.length == 1 ? '0' + seconds : seconds)
                    )
                }
            </p>
            
        </div>
    );
};
export default Countdown;